/* eslint-disable no-unused-expressions */
import { useQuery } from "react-query";
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Button from "../Buttons/Button/Button";
import MsxIcons from "../Icons/MsxIcons/MsxIcons";
import t from "../../utils/translation/translator";
import { getNotifications } from "../../utils/api/api";

const Snackbar = ({ id, opened, onClose, hideCTA, customMessage, ...props }) => {
  const [notifications, setNotifications] = useState(null);
  const { refetch: execGetNotificationsJson } = useQuery(
    "GET_NOTIFICATIONS_JSON",
    async () => {
      try {
        const notificationsJson = await getNotifications();
        setNotifications(notificationsJson);
        return notificationsJson;
      } catch (error) {
        console.error("ERR", error.response?.status);
      }
      return undefined;
    },
    {
      enabled: false
    }
  );

  useEffect(() => {
    execGetNotificationsJson();
  }, []);

  const discoverBaseApiUrl = () => {
    const { origin } = window.location;
    // const { lang, country } = getAppLocaleAsObject();
    const locale = window.msizerConfiguration?.locale || "en-WW";
    const { lang, country } = {
      lang: locale?.split("-")?.[0],
      country: locale?.split("-")?.[1]
    };
    const correctedCountry = country === "GB" ? "UK" : country;
    let result;
    if (origin.match(/\bse\.com$/) || origin.match(/\bpre\.se\.com$/)) {
      // Single domain: post to https://www.se.com/ru/ru/product/my-products.
      result = `${origin}/${correctedCountry.toLowerCase()}/${lang.toLowerCase()}`;
    } else if (origin.match(/\bschneider-electric\b/)) {
      // A locale-specific domain: post to https://www.schneider-electric.com.au/en/product/my-products.
      result = `${origin}/${lang.toLowerCase()}`;
    } else {
      // It's workaround solution for local/pre-prod/sqe/dev etc env's
      result = `https://www.schneider-electric.${
        correctedCountry.toLowerCase() === "ww" ? "com" : correctedCountry.toLowerCase()
      }/${lang.toLowerCase()}`;
    }
    return result;
  };

  const url = discoverBaseApiUrl();

  // Get notification attributes from AWS Json file
  const title = t(notifications?.[id]?.title) + customMessage;
  const type = notifications?.[id]?.type || "";
  const actionCTA = notifications?.[id]?.actionCTA;
  const actionURL = notifications?.[id]?.actionURL.replace(/\{url\}/g, url);
  const actionLabel = t(notifications?.[id]?.actionLabel);
  const autoHideDuration = notifications?.[id]?.autoHideDuration || 8000;

  // Set colors and icons depending on notification type
  let color;
  let buttonColor;
  let icon;
  let textColor;

  switch (type) {
    /* case "success":
      color = "bg-primary";
      buttonColor = "green";
      icon = "check_filled";
      textColor = "text-white";
      break; */
    case "warning":
      color = "bg-sunflowerYellow";
      buttonColor = "yellow";
      icon = "alert-filled";
      textColor = "text-gray-800";
      break;
    case "error":
      color = "bg-seRed";
      buttonColor = "red";
      icon = "info-notif";
      textColor = "text-white";
      break;
    default:
      color = "bg-secondary";
      buttonColor = "darkBlue";
      icon = "info";
      textColor = "text-white";
      break;
  }

  useEffect(() => {
    setTimeout(onClose, autoHideDuration);
  }, [id]);

  function actionType() {
    if (actionURL) {
      window.open(actionURL, "_blank").focus();
    } else if (actionCTA) {
      return actionCTA;
    }
    return "";
  }

  return (
    notifications &&
    opened && (
      <div className="print:hidden relative w-full" {...props}>
        <div
          id={`snackbar-notification-${id}`}
          className={`absolute rounded-b-sm h-11 flex space-x-4 z-50 w-full -mt-3 px-3 py-2 items-center ${color}`}
        >
          <MsxIcons name={icon} className={textColor} />
          <span
            className={`flex-1 font-semibold text-sm overflow-hidden text-ellipsis whitespace-nowrap ${textColor}`}
            title={title}
          >
            {title}
          </span>
          {(actionURL || actionCTA) && !hideCTA && (
            <Button
              id={`snackbar-button-${id}`}
              onClick={() => actionType()}
              border={buttonColor}
              textColor={buttonColor}
              classes="md:max-w-[15%]"
              title={actionLabel}
              large
            >
              <div className="overflow-hidden text-ellipsis whitespace-nowrap">{actionLabel}</div>
            </Button>
          )}
          <MsxIcons name="close" onClick={onClose} className={`text-lg ${textColor} cursor-pointer close-modal-btn`} />
        </div>
      </div>
    )
  );
};

Snackbar.propTypes = {
  id: PropTypes.string,
  onClose: PropTypes.func,
  opened: PropTypes.bool,
  hideCTA: PropTypes.bool,
  customMessage: PropTypes.string
};

Snackbar.defaultProps = {
  id: "",
  onClose: undefined,
  opened: false,
  hideCTA: false,
  customMessage: ""
};
export default Snackbar;
